import { render, staticRenderFns } from "./pc-form-tabs.vue?vue&type=template&id=44a811f4&scoped=true&"
import script from "./pc-form-tabs.vue?vue&type=script&lang=ts&"
export * from "./pc-form-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a811f4",
  null
  
)

export default component.exports